<style>

.input{
  display: grid;
  grid-template-columns: 55px 15px;
}
.number{
  grid-column: 1;
}
.arrow{
  grid-column: 2;
}

.date{
  border: 1px rgba(0,0,0,0) solid;
  padding: 10px;
  text-align: center;
}
.sel{
  border: 1px rgba(0,0,0,1) solid;
  background-color: rgba(0,0,0,0.7);
  color: white;
}

</style>

<Dialog show="{showDates}" title="Select A Date" buttons="{buttons}" on:close="{ () => showDates = false}" on:done="{done}">
  
  {#each allDates as item}
    <div class="date {item == selD ? 'sel' : ''}" on:click="{ () => uSelD(item) }">{item}</div>
  {/each}
  
</Dialog>

<div class="input" on:click="{ () => showDates = true }">
  <div class="month">{date}</div>
  <div class="arrow"><i class="icon-keyboard_arrow_down"></i></div>
</div>


<script>

import Dialog from "./Dialog.svelte";

export let date = "DD";
export let month = "MM";

$:{
  if (month) {
    setupDates();
  }
}


let showDates = false;
let buttons = [ {text: "Done", callback: "done", disabled: true, } ]
let selD = 0;
let allDates = [];

let datesPerMonth = [ 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31, ];


function setupDates() {
  if (month == -1 || month == "MM") return;
  
  allDates = [];
  for (let i = 1; i <= datesPerMonth[month]; i++) {
    allDates.push(i);
  }
}


function uSelD(i) {
  selD = i;
  buttons[0].disabled = false;
}

function done() {
  if (selD != 0) date = selD;
  showDates = false;
}


</script>